export default __webpack_public_path__ + "static/media/f_md-11.8467f95d.svg";